import Vue from 'vue';
import Voucher from "../api/Voucher";
import _ from 'lodash';

export default class VoucherValidator {

    constructor(vouchercode) {
        this.errors = {};
        this.vouchercode = vouchercode;
    }

    flushError(name) {
        Vue.set(this.errors, name, "");
    }

    validateVoucher () {
        this.flushError('vouchercode');
        if(this.vouchercode) {
            Voucher.check(_.toUpper(this.vouchercode)).then(({data}) => {
                if(!data || !data.success) {
                    Vue.set(this.errors, 'vouchercode', 'page_setcontact.error.invalidvoucher');
                }
            });
        }
    }

    validateAll() {
        this.validateVoucher();
    }
}